import { motion } from 'framer-motion'
import { useLanguage } from '../../../contexts/LanguageContext'
import MobileSlideShell from './MobileSlideShell'
import { fadeScaleProps, M_IMAGE_FRAME } from './mobileMotion'

export default function Slide11M() {
  const { t } = useLanguage()
  const s = t.slides.slide11
  const src = s.image || '/slides/slide_11.png'

  return (
    <MobileSlideShell>
      <motion.h2
        {...fadeScaleProps(0)}
        className="text-[26px] font-semibold leading-tight tracking-tight text-[#1B2A6B]"
      >
        {s.title}
      </motion.h2>

      <motion.div {...fadeScaleProps(0.06)} className={M_IMAGE_FRAME}>
        <img src={src} alt="" className="block w-full" loading="lazy" decoding="async" />
      </motion.div>

      <motion.p
        {...fadeScaleProps(0.12)}
        className="text-[16px] leading-relaxed text-[#1B2A6B]/70"
      >
        {s.body}
      </motion.p>

      <motion.div
        {...fadeScaleProps(0.18)}
        className="rounded-2xl border border-white/50 bg-white/70 p-5 shadow-[0_4px_20px_rgba(0,0,0,0.06)] backdrop-blur-md"
      >
        <p className="text-[16px] leading-relaxed text-[#1B2A6B]/80">{s.box}</p>
      </motion.div>
    </MobileSlideShell>
  )
}
